export const ConfirmOptions = [
  {
    label: 'Select',
    value: ''
  },
  {
    label: 'Esim',
    value: 'esim'
  }
]